/* mjn-form.js — Mon Joli Néon (dévis) */
(() => {
  // === METS ICI TON URL WORKER CLOUDFLARE ===
  const PROXY_URL = "https://mjn-make-proxy.contact-b31.workers.dev"
; // <-- remplace par TON URL exacte
  window.MJN_PROXY_URL = PROXY_URL; // debug
  console.log("[MJN] PROXY_URL =", PROXY_URL);

  // --- Affichage du nom de la pièce jointe ---
// met à jour “Aucun fichier” -> “nom_de_fichier.ext” dès qu’un fichier est choisi
function mjnUpdateFileName() {
  const root = document.querySelector('.mjn-quote');
  const input = root?.querySelector('#mjn_file');
  const nameEl = root?.querySelector('#mjn_file_name');
  if (nameEl) {
    nameEl.textContent = (input?.files?.[0]?.name) || 'Aucun fichier';
  }
}

// écoute le changement du champ fichier (même si l’input est stylé via <label for="...">)
document.addEventListener('change', (e) => {
  if (e.target && (e.target.id === 'mjn_file')) {
    mjnUpdateFileName();
  }
}, true);

// optionnel : permet de re-sélectionner le même fichier deux fois d'affilée
document.addEventListener('click', (e) => {
  if (e.target && (e.target.id === 'mjn_file' || e.target.matches('label[for="mjn_file"]'))) {
    const input = document.getElementById('mjn_file');
    if (input) input.value = '';
  }
}, true);

// --- Synchronisation du curseur de taille ---
function mjnSyncSize() {
  const range = document.getElementById('mjn_size');
  const output = document.getElementById('mjn_size_out');
  if (range && output) {
    output.textContent = range.value + ' cm';
  }
}

// met à jour la valeur en direct quand on bouge le curseur
document.addEventListener('input', (e) => {
  if (e.target && e.target.id === 'mjn_size') {
    mjnSyncSize();
  }
}, true);

// initialise la valeur au chargement
document.addEventListener('DOMContentLoaded', mjnSyncSize);

  // === DÉLÉGATION EN CAPTURE (priorité max, évite conflits) ===
  document.addEventListener("submit", async (e) => {
    const root = document.querySelector(".mjn-quote");
    const form = e.target.closest("#mjn-quote-form");
    if (!form || !root) return; // pas notre formulaire

    // on prend vraiment la main
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const success   = root.querySelector("#mjnq-success");
    const errorBox  = root.querySelector("#mjnq-error");
    const submitBtn = root.querySelector("#mjn_submit");
    const range     = root.querySelector("#mjn_size");
    const out       = root.querySelector("#mjn_size_out");
    const fileInput = root.querySelector("#mjn_file");
    const fileName  = root.querySelector("#mjn_file_name");

    const setErr = (msg) => {
      if (errorBox) {
        errorBox.textContent = "Oups… Impossible d’envoyer votre demande. " + (msg || "");
        errorBox.hidden = false;
      }
      if (success) success.hidden = true;
    };
    const setOK = () => {
      if (success) success.hidden = false;
      if (errorBox) errorBox.hidden = true;
    };

    try {
      if (!PROXY_URL || !/^https?:\/\//i.test(PROXY_URL)) {
        setErr("Configuration manquante : PROXY_URL");
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const MAX_MB = 20;
      const f = fileInput?.files?.[0];
      if (f && f.size > MAX_MB * 1024 * 1024) {
        setErr(`Fichier trop lourd (>${MAX_MB} Mo).`);
        return;
      }

      const fd = new FormData(form);
      if (f) fd.set("file", f, f.name);
      fd.append("submitted_at", new Date().toISOString());
      fd.append("page_url", location.href);
      fd.append("source", "MonJoliNeon - Formulaire devis (custom)");

      const oldHTML = submitBtn?.innerHTML;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = "Envoi en cours…";
      }

      // Safari ?
      const ua = navigator.userAgent || "";
      const isSafari = /^((?!chrome|android).)*safari/i.test(ua);

      const sendFetch = async () => {
        const controller = new AbortController();
        const t = setTimeout(() => controller.abort(), 25000);
        try {
          const res = await fetch(PROXY_URL, {
            method: "POST",
            body: fd,
            mode: "cors",
            signal: controller.signal,
          });
          const txt = await res.text().catch(() => "");
          return { ok: res.ok, status: res.status, body: txt };
        } finally {
          clearTimeout(t);
        }
      };

      const sendXHR = () =>
        new Promise((resolve) => {
          const xhr = new XMLHttpRequest();
          xhr.open("POST", PROXY_URL, true);
          xhr.timeout = 25000;
          xhr.onload = () =>
            resolve({
              ok: xhr.status >= 200 && xhr.status < 300,
              status: xhr.status,
              body: xhr.responseText,
            });
          xhr.onerror = () => resolve({ ok: false, status: 0, body: "network error" });
          xhr.ontimeout = () => resolve({ ok: false, status: 0, body: "timeout" });
          xhr.send(fd);
        });

      let resp = isSafari ? await sendXHR() : await sendFetch();
      if (!resp.ok && !isSafari) resp = await sendXHR();

      if (!resp.ok) {
        console.warn("[MJN] worker response", resp);
        setErr(`Détail: HTTP ${resp.status} — ${resp.body || "Réponse non OK"}`);
        return;
      }

      form.reset();
      if (out && range) out.textContent = "100 cm";
      if (fileName) fileName.textContent = "Aucun fichier";
      setOK();
    } catch (err) {
      console.error("[MJN] submit error", err);
      setErr(err?.message || String(err));
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML =
          'Envoyer ma demande <svg class="mjnq__btnicon" viewBox="0 0 24 24" width="18" height="18"><path d="M5 12h12m-6-6l6 6-6 6" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      }
    }
  }, true); // capture = true (priorité)
})();
